module.exports = __webpack_public_path__ + "assets/img/Culture_Julliard.fc9e3434-ps.jpg";